<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiMenuDown } from "@mdi/js";
export default {
  name: "MdiMenuDown",
  data() {
    return {
      svgPath: mdiMenuDown,
    };
  },
};
</script>
